import React from 'react';
import clsx from 'clsx';
import styles from './Typography.module.scss';

type TypographyVariant =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'text'
  | 'caption';

interface Props {
  variant: TypographyVariant;
  children: React.ReactNode;
  className?: string;
}

const tagMap: Record<TypographyVariant, keyof JSX.IntrinsicElements> = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  text: 'p',
  caption: 'span'
};

export function Typography({ variant, children, className }: Props) {
  const Tag = tagMap[variant];

  return <Tag className={clsx(styles[variant], className)}>{children}</Tag>;
}
